<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>

        <v-alert :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" @submit="updateUser" >

              <h2 class="heading-copy pref-heading">Here you can manage your communication preferences from Wigan Athletic Football Club and our Club Partners.</h2>

              <p class="custom-label">Please let us know how you would like to hear from us using the options below, please note that changes may take up to 24 hours to come into effect:</p>

              <v-layout row class="border-bottom sectionRow">
                <v-flex xs12>
                  <v-radio-group
                  :label="`Email`"
                  v-model="clubAll"
                 
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Opt In to receive communications from Wigan Athletic</h3>
                    <p class="custom-label">I wish to receive news and promotions from Wigan Athletic Football Club based on my providing personal data and it’s use outlined in the <a href="https://wiganathletic.com/info/privacy-policy/" target="_blank">Privacy Policy</a>. Clicking yes will select all club marketing, or you can further manage how we contact you using the options below:</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="true"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="false"
                    >
                    </v-radio>
                  
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="clubEmail"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club Mail</h3>
                    <p class="custom-label">Club emails include news, offers, important information and competitions. If you opt out of receiving club email you may miss out on information, offers or reminders relevant to you.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="clubSMS"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club SMS</h3>
                    <p class="custom-label">If providing my mobile number, I am happy to receive club information via SMS.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="clubPhone"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club Phone</h3>
                    <p class="custom-label">If providing my mobile number or a landline number, I am happy to receive club information via telephone.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="clubDirect"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club Direct Mail</h3>
                    <p class="custom-label">If providing my address, I am happy to receive club information via post.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom sectionRow">
                <v-flex xs12>
                  <v-radio-group
                  :label="`Email`"
                  v-model="partnerAll"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Opt In to receive communications from Wigan Athletic Football Club partners</h3>
                    <p class="custom-label">I wish to receive news and promotions from Wigan Athletic Football Club Partners based on my providing personal data and it’s use outlined in the <a href="https://wiganathletic.com/info/privacy-policy/" target="_blank">Privacy Policy</a>. For a list of club partners, please click here. Clicking yes will select all <a href="https://wiganathletic.com/commercial/commercial-partners" target="_blank">Club Partners</a> marketing, or you can further manage how we contact you using the options below:</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="true"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="false"
                    >
                    </v-radio>
                  
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="partnerEmail"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club Partner Email</h3>
                    <p class="custom-label">I am happy to receive club partner news and offers via email.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="partnerSMS"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club Partner SMS</h3>
                    <p class="custom-label">If providing my mobile number, I am happy to receive club partner information via SMS.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="partnerPhone"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label" >
                    <h3 class="label-heading">Club Partner Phone</h3>
                    <p class="custom-label">If providing my mobile number or a landline number, I am happy to receive club partner information via telephone.</p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-radio-group
                  v-model="partnerDirect"
                  :rules="radioRules"
                  row
                  >
                  <span slot="label">
                    <h3 class="label-heading">Club Partner Direct Mail</h3>
                    <p class="custom-label">If providing my address, I am happy to receive club partner information via post. </p>
                  </span>
                    <v-radio
                      label="Yes"
                      :value="`true`"
                    >
                    </v-radio>
                    <v-radio
                      label="No"
                      :value="`false`"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready">Update</button>
              </v-layout>

            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
              :size="50"
              color="accent"
              indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'UserProfileContactPrefs',
  data () {
    
    return {
      ready: false,
      valid: true,
      radioRules: [
        v => !!v || 'You must select your communication preferences to continue' 
      ],
      clubAll: null,
      clubEmail: false,
      clubSMS: false,
      clubPhone: false,
      clubDirect: false,
      partnerAll: null,
      partnerEmail: false,
      partnerSMS: false,
      partnerPhone: false,
      partnerDirect: false,
      error: null,
      success: null,
      loading: false
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
       
        this.clubEmail = userData['custom:club_email']
        this.clubSMS = userData['custom:club_sms']
        this.clubPhone = userData['custom:club_phone']
        this.clubDirect = userData['custom:club_direct']
        this.partnerEmail = userData['custom:partner_email']
        this.partnerSMS = userData['custom:partner_sms']
        this.partnerPhone = userData['custom:partner_phone']
        this.partnerDirect = userData['custom:partner_direct']
        // tell the app that we've finished loading
        this.ready = true

    }, 
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });
    
  },
  watch: {
    clubAll(clubAll) {
      console.log("Watcher on clubAll", this.clubAll)
      if (this.clubAll === true) {
        console.log("2nd Watcher to trigger only on true", this.clubAll)
        this.clubEmail = 'true'
        this.clubSMS = 'true'
        this.clubPhone = 'true'
        this.clubDirect = 'true'
      }
      else if (this.clubAll === false) {
        console.log("3nd Watcher to trigger only on flase", this.clubAll)
        this.clubEmail = 'false'
        this.clubSMS = 'false'
        this.clubPhone = 'false'
        this.clubDirect = 'false'
      }
      else {
        //Nada
      }
    }, 
    partnerAll(partnerAll) {
      console.log("Watcher on partnerAll", this.partnerAll)
      if (this.partnerAll === true) {
        console.log("2nd Watcher to trigger only on true", this.partnerAll)
        this.partnerEmail = 'true'
        this.partnerSMS = 'true'
        this.partnerPhone = 'true'
        this.partnerDirect = 'true'
      }
      else if (this.partnerAll === false) {
        console.log("3nd Watcher to trigger only on flase", this.partnerAll)
        this.partnerEmail = 'false'
        this.partnerSMS = 'false'
        this.partnerPhone = 'false'
        this.partnerDirect = 'false'
      }
      else {
        //Nada
      }
    }
  },

  methods: {
    updateUser (e) {
        e.preventDefault()
        this.ready = false
        var mrktPrefChangeDate = new Date();

        var clubEmail = this.clubEmail.toString();
        var clubSMS = this.clubSMS.toString();
        var clubPhone = this.clubPhone.toString();
        var clubDirect = this.clubDirect.toString();
        var partnerEmail = this.partnerEmail.toString();
        var partnerSMS = this.partnerSMS.toString();
        var partnerPhone = this.partnerPhone.toString();
        var partnerDirect = this.partnerDirect.toString();
        
        var attributesList = {
            "custom:club_email": clubEmail, 
            "custom:club_sms": clubSMS, 
            "custom:club_phone": clubPhone, 
            "custom:club_direct": clubDirect, 
            "custom:partner_email": partnerEmail,
            "custom:partner_sms": partnerSMS,
            "custom:partner_phone": partnerPhone,
            "custom:partner_direct": partnerDirect,
            "custom:mkt_pref_date": mrktPrefChangeDate.toISOString(),
            "custom:mkt_pref_note": 'User updated preferences in SSO profile'
        }
       
        this.$updateAttributes(attributesList).subscribe((response) => {
            console.log("update successful")
            this.error = null
            this.success = response
            this.ready = true
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.success = null
            this.error = err
            this.ready = true
        });    
    },
  }
}
</script>

<style>
  .sectionRow{
    background-color: #e6f8ff;
  }
  .pref-heading, .pref-copy {
    font-family: 'Flama Condensed';
    color: #005ca6;
    font-size: x-large;
    margin-bottom: 36px;
  }
  .border-bottom {
    border-bottom: 1px solid #EEEEEE;
  }
  .label-heading {
    padding-bottom: 8px;
  }
  .v-input--radio-group--row .v-input--radio-group__input {
    flex-wrap: nowrap !important;
  }
  .v-radio {
    align-items: flex-start !important;
  }
  .custom-label {
    margin-right: 40px;
    color: rgba(0,0,0,0.54);
  }
  .v-input__control {
    width: 100% !important;
  }
  .v-label {
    width: 100% !important;
  }
  .layout.row {
    flex-wrap: nowrap !important;
  }
</style>